/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Sendsetup1Inputs */

const zh_password_sendsetup1 = /** @type {(inputs: Password_Sendsetup1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送密码设置邮件`)
};

const en_password_sendsetup1 = /** @type {(inputs: Password_Sendsetup1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send password setup email`)
};

const es_password_sendsetup1 = /** @type {(inputs: Password_Sendsetup1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar correo de configuración`)
};

/**
* | output |
* | --- |
* | "Send password setup email" |
*
* @param {Password_Sendsetup1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const password_sendsetup1 = /** @type {((inputs?: Password_Sendsetup1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Sendsetup1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_password_sendsetup1(inputs)
	if (locale === "en") return en_password_sendsetup1(inputs)
	return es_password_sendsetup1(inputs)
});
export { password_sendsetup1 as "password_sendSetup" }